import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import {
	HomeOutlined,
	FormOutlined,
	ReadOutlined,
	CarOutlined,
	HeartOutlined,
	MedicineBoxOutlined,
	FileTextOutlined,
	ClockCircleOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { getCurrentUserProfile } from "../../../../utilities/AuthService";

const { Sider } = Layout;

const canShowMenstrual = (profile) => {
	if (!profile) {
		return false;
	}
	return (
		profile.gender === "여" &&
		(profile.job === "전도사" || profile.job === "교직원")
	);
};

const LeaveNavigation = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [menuItems, setMenuItems] = useState([]);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			let profile = null;
			try {
				profile = await getCurrentUserProfile();
			} catch (e) {
				/* ignore */
			}
			if (cancelled) {
				return;
			}
			const items = [
				{
					key: "/utils/leave/my-status",
					icon: <ClockCircleOutlined />,
					label: "내 근태 현황",
				},
				{
					key: "/utils/leave/apply-annual",
					icon: <FormOutlined />,
					label: "연차 신청",
				},
				{
					key: "/utils/leave/apply-excuse",
					icon: <FileTextOutlined />,
					label: "사유서",
				},
				{
					key: "/utils/leave/apply-trip",
					icon: <CarOutlined />,
					label: "출장 신청",
				},
				{
					key: "/utils/leave/apply-family-event",
					icon: <HeartOutlined />,
					label: "경조휴가 신청",
				},
				{
					key: "/utils/leave/apply-sick",
					icon: <MedicineBoxOutlined />,
					label: "병가 신청",
				},
			];
			if (canShowMenstrual(profile)) {
				items.push({
					key: "/utils/leave/apply-menstrual",
					icon: <FormOutlined />,
					label: "생리휴가 신청",
				});
			}
			items.push({
				key: "/utils/leave/my-applications",
				icon: <ReadOutlined />,
				label: "내 신청 내역",
			});
			setMenuItems(items);
		})();
		return () => {
			cancelled = true;
		};
	}, []);

	const handleMenuClick = ({ key }) => {
		navigate(key);
	};

	const getSelectedKey = () => {
		const path =
			(location.pathname || "/").replace(/\/+$/, "") || "/";
		const menuItem = menuItems.find((item) => item.key === path);
		if (menuItem) {
			return menuItem.key;
		}
		if (path.startsWith("/utils/apply-for-leave")) {
			return "/utils/leave/apply-annual";
		}
		if (path.startsWith("/utils/leave/my-applications")) {
			return "/utils/leave/my-applications";
		}
		if (path.startsWith("/utils/leave/my-status")) {
			return "/utils/leave/my-status";
		}
		return "/utils/leave/apply-annual";
	};

	return (
		<Sider
			width={250}
			className="member-navigation__sider"
			breakpoint="lg"
			collapsedWidth="0">
			<div className="member-navigation__logo">
				<HomeOutlined />
				<span>근태 신청</span>
			</div>
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={[getSelectedKey()]}
				items={menuItems}
				onClick={handleMenuClick}
				className="member-navigation__menu"
			/>
		</Sider>
	);
};

export default LeaveNavigation;
